import React from 'react';
import { Icon, MobileDrawer, Typography } from '@saviynt/design-system';
import PropTypes from 'prop-types';

import PopoverContent from './PopoverContent';

import './PopoverProgressBreakdown.css';

function PopoverProgressBreakdown({
  closePopover,
  isProgressBarOpen,
  setIsProgressBarOpen,
  isMobileWidth,
  label,
}) {
  if (isMobileWidth) {
    return (
      <MobileDrawer
        isSwipeEnabled
        isOpen={isProgressBarOpen}
        setIsOpen={setIsProgressBarOpen}
        className='PopoverProgressBreakdown-mobileDrawer'
        classNames={{
          focusLockClassName:
            'PopoverProgressBreakdown-mobileDrawer--focusLock',
          focusLockContentClassName:
            'PopoverProgressBreakdown-mobileDrawer--focusLockContent',
          contentClassName: 'PopoverProgressBreakdown-mobileDrawer--content',
        }}
        content={
          <>
            <Typography
              kind='h2'
              mobile='h3-d'
              className='PopoverProgressBreakdown-title'>
              {label}
            </Typography>
            <PopoverContent />
          </>
        }
      />
    );
  }

  return (
    <div className='PopoverProgressBreakdown' role='button' tabIndex='0'>
      <div
        className='PopoverProgressBreakdown-close'
        onClick={closePopover}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            closePopover();
          }
        }}
        tabIndex={0}
        role='button'>
        <Icon kind='Close' color='neutral-1000' size='small' />
      </div>
      <Typography
        kind='h2'
        mobile='h3-d'
        className='PopoverProgressBreakdown-title'>
        {label}
      </Typography>
      <PopoverContent />
    </div>
  );
}

PopoverProgressBreakdown.propTypes = {
  closePopover: PropTypes.func.isRequired,
  isProgressBarOpen: PropTypes.bool.isRequired,
  setIsProgressBarOpen: PropTypes.func.isRequired,
  isMobileWidth: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
};

PopoverProgressBreakdown.defaultProps = {};

export default PopoverProgressBreakdown;
